import axios from "axios";


class AuthHeader {

    apiUrl(){
        const api_Url = axios.create({
            baseURL :"/api",
            headers: this.tokenUser()
        })
        return api_Url
    }

    tokenUser(){
        const vuex = JSON.parse(localStorage.getItem("vuex"));
        return {
            Accept: 'application/json',
            DOLAPIKEY: vuex.token,
            DOLAPIENTITY: vuex.user?.entity
        };
    }

}

export default new AuthHeader();
